import React from 'react'

const Manual_siigo_mapeo_journals = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">Siigo - Mapeo de Journals</h2>
        <iframe
          src="https://scribehow.com/embed/Siigo__Mapeo_de_Journals__xUTm_OIXTBKiHrHvfplDRw?as=scrollable"
          className="scribe-iframe-general-190"
          width="100%"
          height="3800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_siigo_mapeo_journals
